import type { SVGProps } from 'react';

export const BlurbLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 52 51"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      d="M52 .333v40.583H19.5L0 50.656V10.074L19.5.334H52ZM6.5 20.622v12.17h2.629V31.79c.585.787 1.538 1.212 2.629 1.212 2.477 0 4.08-2.07 4.08-4.768s-1.625-4.74-4.08-4.74c-1.076 0-2.051.41-2.63 1.212v-4.083H6.5Zm14.41 3.073v6.053c0 1.825 1.076 3.253 3.004 3.253 1.127 0 2.08-.476 2.629-1.19v.99h2.606v-9.099h-2.606v5.18c0 1.176-.737 1.804-1.69 1.804-1.062 0-1.315-.765-1.315-1.55v-5.441H20.91Zm16.196-3.073v12.17h2.63V31.79c.584.787 1.538 1.212 2.628 1.212 2.477 0 4.08-2.07 4.08-4.768s-1.624-4.74-4.08-4.74c-1.076 0-2.05.41-2.629 1.212v-4.083h-2.629Zm-20.307.006V32.8h2.629V20.63h-2.63Zm18.705 2.915c-.939 0-1.712.477-2.203 1.278v-1.126h-2.63v9.104h2.63v-4.004c0-1.84.866-2.64 1.942-2.64.275 0 .55.05.752.137l.007-.008.39-2.59c-.174-.086-.614-.15-.888-.15Zm6.231 2.2c1.337 0 1.965 1.162 1.965 2.526 0 1.363-.636 2.49-1.965 2.49-1.328-.001-1.993-1.127-1.993-2.49 0-1.363.658-2.525 1.993-2.525Zm-30.613 0c1.336 0 1.965 1.162 1.965 2.526 0 1.363-.636 2.488-1.965 2.488-1.329 0-1.993-1.125-1.993-2.488 0-1.364.657-2.525 1.993-2.525Z"
    />
  </svg>
);
